
import { node } from "~/util/dom";
import { createHeader } from "~/profile/utils/header";
import { _ } from "~/i18n";
import createLinkButton from "~/ui/linkbutton";
import { SettingsUserSpeedPopup } from "~/profile/settings/userspeed/popup";

export interface ISettingsUserSpeedProps {
	title: string;
	desc: string;
}

export default class SettingsUserSpeed {
	#container: HTMLDivElement;

	#props: ISettingsUserSpeedProps;

	#popup: SettingsUserSpeedPopup;

	constructor(props: ISettingsUserSpeedProps) {
		this.#container = node("div", { className: `settings-button` });
		this.#props = props;
		this.#popup = null;

		this.#build();
	}

	destroy() {
		this.#container.innerHTML = "";
		this.#popup?.destroy();
	}

	get container() {
		return this.#container;
	}

	#build() {
		const header = createHeader("settings-button", this.#props.title);
		const titlePara = node("p", { className: "desc" }, this.#props.desc);
		const editButton = createLinkButton({
			innerHTML: `${_("set")}`,
		});

		editButton.addEventListener("click", () => {
			this.#showPopup();
		});

		header.append(editButton);

		this.#container.append(header, titlePara);
	}

	#showPopup() {
		if (!this.#popup) {
			this.#popup = new SettingsUserSpeedPopup();
		}
		this.#popup.open();
	}
}
